import { tokenDuck } from '../../store/jwtMiddleware';
import { getConfigurationAction } from './configuration';
import { fetchOrganizationAction } from './organization';
import { fetchUserAction } from './user';

export const initialize = () => async (dispatch, getState) => {
  const token = tokenDuck.selectors.token(getState());
  if (token) {
    await Promise.all([fetchOrganizationAction(token)(dispatch, getState), fetchUserAction(token)(dispatch, getState)]);
    dispatch(getConfigurationAction(token));
  }
};
